import React, { Component } from 'react';
//import { withRouter } from 'react-router';
import { Icon } from 'react-materialize';
import EventUtils from '../../utils/EventUtils';

import './StatusInformation.css';

class StatusInformation extends Component {
  constructor(props){
    super(props);

    this._handleBackClick = this._handleBackClick.bind(this);
  }

  _handleBackClick(event){
    EventUtils.raiseEvent('back-click', { }, this.props);
  }

  render() {
  const { title, subtitle } = this.props;

    return (
      <div className="status-information">
        <div className="main">
          <header className="main-header">
            <span className="btn-link" id="navTabSearch" onClick={ this._handleBackClick }>
              <Icon tiny>arrow_back</Icon> Back
            </span>
          </header>

          <div>
            <h1 className="title">{ title }</h1>
            <h2 className="subtitle">{ subtitle }</h2>
          </div>
        </div>
      </div>
    );
  }
}

export default StatusInformation;
